import React from 'react';
import MainLayout from '../../layout/MainLayout';
import TradersView from '../../components/user-management/TradersView';

const TradersViewPage = () => {
  return (
    <MainLayout>
        <TradersView />
    </MainLayout>
  )
}

export default TradersViewPage